<mat-expansion-panel
  class="box-shadow border-radius-0"
  (afterExpand)="onExpanded()"
>
  <mat-expansion-panel-header>
    <mat-panel-title class="panel-header-title">
      <mat-icon [inline]="true" class="opacity-4">flight</mat-icon>
      <span>Aircraft</span>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <ng-template matExpansionPanelContent>
    <div
      *ngIf="{
        details: details$ | async,
        mels: mels$ | async,
        routing: routing$ | async
      } as vm"
    >
      <app-data-box
        headerTitle="Details"
        [dataItems]="vm.details?.response?.dataItems"
        [isLoading]="vm.details?.isLoading && !vm.details?.response"
        class="mt-24"
      >
        <div
          *ngIf="
            !vm.details?.isLoading &&
            (!vm.details?.response ||
              vm.details?.response?.dataItems?.length === 0)
          "
          class="data-box-content text-center text-sm"
        >
          Aircraft details unavailable
        </div>
      </app-data-box>
      <app-data-box headerTitle="MELs" class="mt-32">
        <div class="data-box-content">
          <div *ngIf="vm.mels?.isLoading && !vm.mels?.response">
            <div class="flex-center">
              <mat-spinner color="accent" [diameter]="32"></mat-spinner>
            </div>
          </div>
          <table
            *ngIf="vm.mels?.response && vm.mels!.response!.length > 0"
            class="caution-color"
          >
            <tr *ngFor="let mel of vm.mels?.response">
              <td class="mel-type">{{ mel?.type }}</td>
              <td class="mel-id">{{ mel?.id }}</td>
              <td class="mel-description">{{ mel?.description }}</td>
            </tr>
          </table>
          <div
            *ngIf="vm.mels?.response?.length === 0"
            class="font-medium success-color text-base"
          >
            No MELs
          </div>
          <div
            *ngIf="!vm.mels?.isLoading && !vm.mels?.response"
            class="text-center text-sm"
          >
            MELs unavailable
          </div>
        </div>
      </app-data-box>
      <app-data-box
        headerTitle="Today's Routing"
        [isLoading]="vm.routing?.isLoading && !vm.routing?.response"
        [helpComponent]="routingInfoComponent"
        class="mt-32"
      >
        <div class="data-box-content table-container">
          <table mat-table *ngIf="vm.routing?.response" class="width-100">
            <thead>
              <th class="text-right px-8">Flt</th>
              <th class="px-8">From</th>
              <th class="px-8">To</th>
              <th class="text-center px-8">Status</th>
            </thead>
            <tr *ngFor="let leg of vm.routing?.response?.legs">
              <td class="font-medium text-right px-8">
                {{ leg.flightNumber }}
              </td>
              <td class="px-8 from-to">
                <span class="font-medium">{{ leg.from }} </span>
                <span class="time">{{ leg.depTime }}</span>
              </td>
              <td class="px-8 from-to">
                <span class="font-medium">{{ leg.to }} </span>
                <span class="time">{{ leg.arrTime }}</span>
              </td>
              <td class="text-center px-8">
                <mat-icon *ngIf="leg.status === 'landed'" class="success-color"
                  >task_alt</mat-icon
                >
                <mat-icon *ngIf="leg.status === 'scheduled'" class="opacity-4"
                  >schedule</mat-icon
                >
                <mat-icon *ngIf="leg.status === 'in flight'" class="info-color"
                  >flight_takeoff</mat-icon
                >
              </td>
            </tr>
          </table>
          <div
            *ngIf="vm.routing?.isCompleteWithNoResponse()"
            class="text-center text-sm"
          >
            Routing unavailable
          </div>
        </div>
      </app-data-box>
      <div class="flex-center mt-24">
        <a
          [href]="getSafeLink(vm.details?.response?.aircraftNumber || '')"
          target="_blank"
          class="thin-gray-border safe-link link font-bold text-sm"
        >
          <mat-icon class="icon-sm">launch</mat-icon>
          SAFE</a
        >
      </div>
      <div class="data-status">
        <app-data-status
          [isLoading]="
            vm.details?.isLoading || vm.mels?.isLoading || vm.routing?.isLoading
          "
          [timestamp]="vm.details?.response?.timestamp"
          (refresh)="refresh()"
        ></app-data-status>
      </div>
      <mat-progress-bar
        *ngIf="
          vm.details?.isLoading || vm.mels?.isLoading || vm.routing?.isLoading
        "
        class="progress-bar-bottom"
        color="accent"
        mode="indeterminate"
      ></mat-progress-bar>
    </div>
  </ng-template>
</mat-expansion-panel>
